var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sps-card sps-card--announcement",class:{ 'is-pinned': _vm.card.pinned }},[_c('div',{staticClass:"sps-card__title"},[_vm._v(_vm._s(_vm.lc.title))]),_c('p',{staticClass:"sps-card__body"},[_vm._v(_vm._s(_vm.lc.body))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48491e83","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/V2/shell/cards/AnnouncementCard.vue
// module id = skp4
// module chunks = 0